import { useState } from "react";

import {
  AbasRegrasCanais,
  type AbaRegrasCanais,
} from "../regras/AbasRegrasCanais";
import { SecaoCanais } from "../regras/SecaoCanais";
import { SecaoRegras } from "../regras/SecaoRegras";

/*
 * Página da Tela 6 — Regras e Canais de Alerta (FE-6a + FE-6b).
 *
 * As duas fatias estão completas: CANAIS (CRUD + testar — FE-6a) e REGRAS (CRUD —
 * FE-6b). O default da aba ativa é "regras" (a primária — decisão de produto).
 *
 * Estrutura: título + `<AbasRegrasCanais>` (controlada) + conteúdo por aba. No
 * `<main>` do Shell (a rota `/regras` vive sob o guard). SÓ tokens CPMH.
 */

export function RegrasCanais(): JSX.Element {
  const [abaAtiva, setAbaAtiva] = useState<AbaRegrasCanais>("regras");

  return (
    <section className="flex flex-col gap-6">
      <h1 className="font-titulo text-2xl text-off-black">
        Regras e Canais de Alerta
      </h1>

      <AbasRegrasCanais abaAtiva={abaAtiva} aoTrocar={setAbaAtiva} />

      {abaAtiva === "regras" ? <SecaoRegras /> : <SecaoCanais />}
    </section>
  );
}
